import React from "react";

import { SwitchCheckbox } from "../SwitchCheckbox";
import {useToggleEdit} from "../../hooks/useToggleEdit";

export const EditControl: React.FC = () => {
  const { isEdit, canEdit, toggleIsEdit } = useToggleEdit();

  return (
    <SwitchCheckbox
      label="Edit text"
      checked={isEdit}
      disabled={!canEdit}
      onChange={toggleIsEdit}
    />
  );
};
